export function fetchClaimReport({ reportId }) {
  return {
    endpoint: `reports/${reportId}`,
    method: 'GET',
    requireAuth: false,
  };
}
